import DashboardPage from "@pages/dashboard"
import ChatPage from "@pages/chats"
import AppointmentsPage from "@pages/appointments"
import CabBookingsPage from "@pages/cab-bookings"
import PatientCaseFilesPage from "@pages/patient-case-files"
import ct from "@constants/"
import ServicePage from "@/pages/services"
import ServiceDetailsPage from "@/pages/service-details"
import DoctorPage from "@/pages/doctors"
import UserManagementPage from "@/pages/user-management"
import DoctorDetailsPage from "@/pages/doctors/DoctorDetailsPage"
import PatientDetailsPage from "@/pages/patient-case-files/[id]"

const mainRoutes = [
  { path: ct.route.ROOT, element: <DashboardPage /> },
  { path: ct.route.CHATS, element: <ChatPage /> },
  { path: ct.route.APPOINTMENTS, element: <AppointmentsPage /> },
  { path: ct.route.CAB_BOOKINGS, element: <CabBookingsPage /> },
  { path: ct.route.PATIENTS, element: <PatientCaseFilesPage /> },
  { path: `${ct.route.PATIENTS}/:id`, element: <PatientDetailsPage /> },
  { path: ct.route.SERVICES, element: <ServicePage /> },
  { path: `${ct.route.SERVICES}/:id`, element: <ServiceDetailsPage /> },
  { path: ct.route.DOCTORS, element: <DoctorPage /> },
  { path: ct.route.USER_MANAGEMENT, element: <UserManagementPage /> },

  { path: `${ct.route.DOCTORS}/:id`, element: <DoctorDetailsPage /> },
]

export default mainRoutes
